import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../api/api";

//Fetch indicator master list
export const fetchIndicators = createAsyncThunk("master/indicators", async () => {
    try {
        const response = await get("/indicators")
        return response;
    } catch (error) {
        console.log(error)
    }
});

//Fetch roles master list
export const fetchRoles = createAsyncThunk("master/roles", async () => {
    try {
        const response = await get("/roles")
        return response;
    } catch (error) {
        console.log(error)
    }
});

//Fetch reports master list
export const fetchReports = createAsyncThunk("master/reports", async () => {
    try {
        const response = await get("/reports")
        return response;
    } catch (error) {
        console.log(error)
    }
});

//Fetch ministries master list
export const fetchMinistries = createAsyncThunk("master/ministries", async () => {
    try {
        const response = await get("/ministries")
        return response;
    } catch (error) {
        console.log(error)
    }
});